import styled from '@emotion/styled/macro';
import { BaseButton, DataTable, forPhoneOnly, TitleCard, Variables } from '@enter/core';
import { Icon } from '@mdi/react';
import { PageLayoutHeader } from 'components';

export const Cell = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex-grow: 1;
    padding: 16px;
    overflow-y: auto;
`;

export const Header = styled(PageLayoutHeader)`
    justify-content: space-between;
    ${forPhoneOnly(`
        flex-direction: column;
    `)};
`;

export const StyledIcon = styled(Icon)`
    fill: white;
`;

export const BadgeIcon = styled(Icon)``;

export const StyledButton = styled(BaseButton)`
    ${forPhoneOnly(`
        margin-top: 12px;
    `)};
`;

const hoverable = `
    &:hover {
        background-color: ${Variables.Colors.p50};
        circle.dot {
            fill: ${Variables.Colors.b300};
        }
        circle.open {
            fill: ${Variables.Colors.white};
            stroke: ${Variables.Colors.b300};
        }
        line.fg {
            stroke: ${Variables.Colors.b300};
        }
        line.bg {
            stroke: ${Variables.Colors.p50};
        }
    }
`;

export const StyledDataTable = styled(DataTable)`
    display: flex;
    flex-direction: column;
    margin: 12px 0;
    min-height: 100px;
    width: 100%;

    & > div {
        overflow-y: hidden;
    }

    div[role='table'] > div:first-of-type {
        [role='columnheader'] {
            white-space: nowrap;
        }
    }

    div[role='row'] {
        ${hoverable}
    }

    div[role='columnheader'] {
        padding: 8px 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    div[role='cell'] {
        font-size: 15px;
        color: ${Variables.Colors.n70};
        padding: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const StyledHeader = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 24px;
`;

export const StyledTitleCard = styled(TitleCard)`
    & > section > section:first-of-type {
        display: none;
    }
    width: 100%;
`;

export const ExpandContainer = styled.section`
    font-size: 18px;
    letter-spacing: 0.5px;
    padding: 4px 8px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ClickableContainer = styled.div`
    cursor: pointer;
`;

export const DocumentWrapper = styled.div<{ loading: boolean }>`
    opacity: ${({ loading }) => (loading ? 0.7 : 1)};
`;

export const AccountPhone = styled.a`
    color: ${Variables.Colors.b300};
    line-height: 18px;
    letter-spacing: 0.2px;
    text-align: right;
    cursor: pointer;
    white-space: nowrap;
`;

export const MailIcon = styled(Icon)`
    margin-left: 5px;
    fill: ${Variables.Colors.b300};

    cursor: pointer;

    &:hover {
        fill: ${Variables.Colors.b500};
    }
`;

export const BadgeBody = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

interface ISelectableProps {
    selectable: boolean;
}

export const StyledSegment = styled.span`
    display: block;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    padding: 8px 4px;
    line-height: 24px;
    height: 100%;
    width: 50px;
    padding: 0;
`;

export const AccountEmail = styled.a`
    color: black;
    display: flex;
    gap: 5px;
`;
